import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout, { PolicySection } from "./PolicyLayout";

const policies = [
  ["Terms of Service & Sale", "/terms", "Rules for using the site and purchasing products."],
  ["Privacy Policy", "/privacy", "How personal information is collected, used, shared, and protected."],
  ["Personal Information Collection Statement", "/data-collection", "The notice that applies when you submit personal information."],
  ["Cookie & Local Storage Policy", "/cookies", "Browser storage used for the cart and essential store functions."],
  ["Shipping & Delivery Policy", "/shipping", "Dispatch, tracking, customs, delays, and delivery issues."],
  ["Returns & Refunds Policy", "/returns", "Eligibility, exclusions, return steps, exchanges, and refunds."],
  ["Payment & Pricing Policy", "/payments", "Currency, payment processing, taxes, authorisations, and price errors."],
  ["Order Changes & Cancellation Policy", "/cancellations", "How to request an address change or cancellation."],
  ["Warranty & Faulty Goods Policy", "/warranty", "Remedies for defects, incorrect goods, and manufacturing faults."],
  ["Product Care & Safety Guide", "/product-care", "Jewellery care, materials, allergies, small parts, and safety notices."],
  ["Promotions Policy", "/promotions", "Discount codes, free gifts, offer limits, and returns from promotions."],
  ["Gift Cards & Store Credit Policy", "/gift-cards", "Terms that apply if gift cards or store credit are offered."],
  ["Intellectual Property & Takedown Policy", "/intellectual-property", "Permitted use of site content and rights-owner notices."],
  ["Accessibility Statement", "/accessibility", "Our accessibility approach and how to report a barrier."],
  ["Security & Fraud Prevention", "/security", "Payment security, account safety, fraud review, and phishing reports."],
  ["Complaints & Dispute Resolution", "/complaints", "How to raise and escalate a service or purchase complaint."],
];

function PolicyCenter() {
  return (
    <PolicyLayout
      title="Store Policy Centre"
      intro="These policies explain how the mefurvexo online store works before, during, and after a purchase. Product-specific information shown on a product page or at checkout also forms part of the purchase information."
      contactSubject="our store policies"
    >
      <PolicySection title="Policies and customer information">
        <ul className="policy-grid">
          {policies.map(([title, path, description]) => (
            <li className="policy-card" key={path}>
              <Link to={path}>
                <strong>{title}</strong>
                <span>{description}</span>
              </Link>
            </li>
          ))}
        </ul>
      </PolicySection>
      <PolicySection title="How these policies work together">
        <p>
          If two statements appear to conflict, product-specific terms or an
          offer&apos;s clearly disclosed terms apply to that product or offer. Nothing
          in these policies removes a right or remedy that cannot lawfully be
          excluded in the customer&apos;s place of residence.
        </p>
      </PolicySection>
    </PolicyLayout>
  );
}

export default PolicyCenter;
